import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Box,
  TextField,
  IconButton,
  Typography,
  Paper,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { useForm } from "react-hook-form";

import PhotoCamera from "@mui/icons-material/PhotoCamera";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

function EditCrumbModal({
  crumbId,
  crumbName,
  crumbImage,
  editCrumbModalState,
  setEditCrumbModalState,
  handleCrumbEdit,
}) {
  const dispatch = useDispatch();
  const browserWidth = window.innerWidth; 
  const [rename, setRename] = useState(crumbName);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(crumbImage);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const { handleSubmit } = useForm();

  useEffect(() => {
    setRename(crumbName);
    setImagePreview(crumbImage);
    setImage(null);
  }, [editCrumbModalState, crumbName, crumbImage]);

  const handleClose = () => {
    dispatch(setEditCrumbModalState(false));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const onSubmit = () => {
    // setIsSubmitting(true); 
    handleCrumbEdit(crumbId, rename, image, setEditCrumbModalState);
   
  };

  return (
    <Dialog
      open={editCrumbModalState}
      onClose={handleClose}
      PaperProps={{ sx: { width: "390px", borderRadius: "12px", mx: 2 } }}
    >
      <DialogTitle textAlign="center" sx={{ fontWeight: 600, fontSize: '1.25rem' }}>
        Edit Crumb
      </DialogTitle>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
      >
        <DialogContent sx={{ px: browserWidth > 500 ? 4 : 3, pt: 1 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {/* 1. Title Field is now first */}
            <TextField
              autoFocus
              label="Crumb Name"
              type="text"
              variant="outlined"
              fullWidth
              value={rename}
              onChange={(e) => setRename(e.target.value)}
            />
            
            {/* 2. Dedicated Image Upload Area */}
            <Box sx={{ width: '100%' }}>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#555' }}>
                Crumb Image
              </Typography>
              <Paper
                variant="outlined"
                sx={{
                  position: "relative",
                  width: "100%",
                  height: "180px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 2,
                  overflow: "hidden", // Ensures image and icon stay within borders
                  backgroundColor: '#f9f9f9',
                }}
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  id="crumb-image-upload"
                  onChange={handleImageChange}
                />
                {imagePreview ? (
                  <>
                    <img
                      src={imagePreview}
                      alt="Crumb preview"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                    {/* Icon to change the image, appears on top */}
                    <IconButton
                      component="label"
                      htmlFor="crumb-image-upload"
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        backdropFilter: 'blur(4px)',
                        color: 'black',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 1)',
                        }
                      }}
                    >
                      <PhotoCamera />
                    </IconButton>
                  </>
                ) : (
                  <Box
                    component="label"
                    htmlFor="crumb-image-upload"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%',
                      cursor: 'pointer',
                      color: '#888',
                      '&:hover': {
                        backgroundColor: '#f0f0f0'
                      }
                    }}
                  >
                    <AddPhotoAlternateIcon sx={{ fontSize: 40 }} />
                    <Typography variant="body2">Click to upload</Typography>
                  </Box>
                )}
              </Paper>
            </Box>
          </Box>
        </DialogContent>
        <Divider sx={{ mt: 3 }}/>
        <DialogActions sx={{ p: '16px' }}>
            <Button variant="text" onClick={handleClose} sx={{textTransform: 'none', fontSize: '1rem'}}>Cancel</Button>
            <LoadingButton
                type="submit"
                // loading={isSubmitting}
                variant="contained"
                disableElevation
                sx={{ borderRadius: '8px', textTransform: 'none', fontSize: '1rem', px: 3 }}
            >
                Save Changes
            </LoadingButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
}



export default EditCrumbModal;
